import Axios from './Axios';
import { isKoba } from './Auth';

export const getAssignments = () => Axios.get('/assignments');
export const getInstances = () => Axios.get('/instances');

export const fetchServices = () => (isKoba() ? getInstances() : getAssignments());
